var _path, _circle, _circle2, _circle3, _circle4, _circle5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5816 8.53698C10.7517 8.36537 10.7504 8.08836 10.5788 7.91827C10.4072 7.74818 10.1302 7.74941 9.9601 7.92103L8.94083 8.94943C8.52717 9.3668 8.24248 9.6531 8.00126 9.84682C7.76693 10.035 7.61642 10.0996 7.48163 10.1167C7.39699 10.1275 7.31135 10.1275 7.22671 10.1167C7.09191 10.0996 6.9414 10.035 6.70708 9.84683C6.46585 9.6531 6.18116 9.3668 5.7675 8.94943L4.74824 7.92103C4.57815 7.74941 4.30114 7.74818 4.12952 7.91827C3.95791 8.08836 3.95667 8.36537 4.12676 8.53698L5.16439 9.58391C5.55519 9.97822 5.87459 10.3005 6.15918 10.5291C6.45512 10.7667 6.75551 10.9388 7.11607 10.9847C7.27417 11.0049 7.43416 11.0049 7.59226 10.9847C7.95283 10.9388 8.25321 10.7667 8.54915 10.5291C8.83374 10.3005 9.15314 9.97823 9.54394 9.58391L10.5816 8.53698Z",
    fill: "#2F3259"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 3.5,
    r: 0.5,
    transform: "rotate(180 11.5 3.5)",
    fill: "#2F3259"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 3.5,
    r: 0.5,
    transform: "rotate(180 9.5 3.5)",
    fill: "#2F3259"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 3.5,
    r: 0.5,
    transform: "rotate(180 7.5 3.5)",
    fill: "#2F3259"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 3.5,
    r: 0.5,
    transform: "rotate(180 5.5 3.5)",
    fill: "#2F3259"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 0.5,
    transform: "rotate(180 3.5 3.5)",
    fill: "#2F3259"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.8a762c2bc859a907e6830d06a16e1674.svg";
export { ForwardRef as ReactComponent };